export const handleEvalinkInput = (
  setCamerasObject: any,
  camerasObject: any,
  inputString: string,
  objectId: number | null,
  inputNameString: string
) => {
  // Update localStorage first so AutoAddTable doesn't overwrite our changes.
  // Site-level fields (token / device id / company id / partition id) are
  // shared across all cameras; alarm_zone_id is per camera and deliberately
  // never stored here (ENG-352: each camera's zone must be typed in, no
  // silent duplicates).
  const evalinkAlertPostObject = JSON.parse(
    localStorage.evalinkAlertPostObject || "{}"
  );

  if (inputNameString === "evalinkToken") {
    evalinkAlertPostObject.evalink_token = inputString;
  }
  if (inputNameString === "evalinkDeviceId") {
    evalinkAlertPostObject.evalink_device_id = inputString;
  }
  if (inputNameString === "evalinkCompanyId") {
    evalinkAlertPostObject.evalink_company_id = inputString;
  }
  if (inputNameString === "partitionId") {
    evalinkAlertPostObject.partition_id = inputString;
  }

  if (inputNameString !== "alarmZoneId") {
    localStorage.setItem(
      "evalinkAlertPostObject",
      JSON.stringify(evalinkAlertPostObject)
    );
  }

  // Create a deep copy of the camerasObject to ensure React detects the change
  const newCamerasObject = { ...camerasObject };

  for (const key in camerasObject) {
    newCamerasObject[key] = {
      ...camerasObject[key],
      evalink: {
        ...camerasObject[key].evalink,
      },
    };
  }

  if (objectId) {
    // Handle single object update (per-camera alarm zone)
    if (inputNameString === "alarmZoneId") {
      newCamerasObject[objectId].evalink.alarm_zone_id = inputString;
    }

    setCamerasObject((previousState: any) => {
      return { ...previousState, [objectId]: newCamerasObject[objectId] };
    });
  } else {
    // Handle all objects update (site-level fields)
    if (inputNameString === "evalinkToken") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].evalink.evalink_token = inputString;
      }
    }
    if (inputNameString === "evalinkDeviceId") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].evalink.evalink_device_id = inputString;
      }
    }
    if (inputNameString === "evalinkCompanyId") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].evalink.evalink_company_id = inputString;
      }
    }
    if (inputNameString === "partitionId") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].evalink.partition_id = inputString;
      }
    }

    setCamerasObject(newCamerasObject);
  }
};
